// components/StickyLayout.js

import LayoutCard from './LayoutCard';
import styles from './StickyLayout.module.scss';

const StickyLayout = () => {
    const list1: Array<string> = [
        "Account-Specific Catalogs",
        "Supplier Workflow",
        "Distributor Workflows",
        "Dealer Workflows",
        "Distributed Warehouse",
        "Multi-lingual",
        "Vendor Management",
    ];
    const list2: Array<string> = [
        "Inventory and Ledgers",
        "Procurement Lifecycle",
        "Purchase Orders Workflow",
        "Returns and E-Invoicing",
        "E-Invoicing",
        "Credit Management",
        "Debit Management",
        "Demand Forcasting",
    ];
    const list3: Array<string> = [
        "Marketplace Generator",
        "RFQ's",
        "Biding",
        "Bulk Orders",
        "Inter Business Workflows",
        "Bulk Order Fulfilment",
        "Enquiry Process",
        "Price Negotiators",
        "Customer Data Intelligence",
        "Brand Intelligence",
        "On-Page Analytics",
        "Off-Page Analytics",
        "Sales Management",
        "Margin Selectors"

    ];
    const list4: Array<string> = [
        "Our Commerce APIs",
        "External POS",
        "CRM",
        "Powered with AI",
        "3PL Integrations",
        "Social Media Connectors",
        "Marketing",
        "Customer Support"
    ];

    const data = [
        {
            image: "",
            heading: "Vertical Agnostic",
            subheading: "Vertical Agnostic Whether you have a team of 2 or 200, our shared team inboxes keep everyone on the same page and in the loop.",
            list: list1,
            price: "",
        },
        {
            image: "",
            heading: "Inventory & Books",
            subheading: "Whether you have a team of 2 or 200, our shared team inboxes keep everyone on the same page and in the loop.",
            list: list2,
            price: "",
        },
        {
            image: "",
            heading: "Bridge B2B - B2C",
            subheading: "Whether you have a team of 2 or 200, our shared team inboxes keep everyone on the same page and in the loop.",
            list: list3,
            price: "",
        },
        {
            heading: "Integrations",
            subheading: "Whether you have a team of 2 or 200, our shared team inboxes keep everyone on the same page and in the loop.",
            list: list4,
            price: "$0.9/IP",
        },
    ];

    return (
        <div className={styles["wrapper"]}>
            <div className={styles["ai-cardlist-wrapper"]}>
                <h2>What makes us a future-forward B2B platform?</h2>
                <p>
                    Explore our comprehensive features that address every b2b use case
                </p>
                <div className={styles["ai-cardlist"]}>
                    {data.map((item, index) => (
                        <LayoutCard
                            key={index}
                            heading={item.heading}
                            subHeading={item.subheading}
                            list={item.list}
                            price={item.price}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default StickyLayout;
